import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Target, Users, Building2, Code2, Briefcase } from 'lucide-react';

const RoleSelection = () => {
  const { user, isManager, isSuperAdmin, isDeveloper } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Welcome, {user?.displayName}</h1>
          <p className="text-gray-500 mt-2">Select how you'd like to proceed</p>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <button
            onClick={() => navigate('/dashboard')}
            className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow text-left group"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg mb-4 group-hover:bg-blue-200 transition-colors">
              <Target className="w-6 h-6 text-blue-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">My Goals</h2>
            <p className="text-gray-500 mt-2">Create, view, and track your quarterly goals</p>
          </button>

          {isManager && (
            <button
              onClick={() => navigate('/manager')}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow text-left group"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 rounded-lg mb-4 group-hover:bg-green-200 transition-colors">
                <Users className="w-6 h-6 text-green-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900">Review Team Goals</h2>
              <p className="text-gray-500 mt-2">Review and approve your team members' goals</p>
            </button>
          )}

          {isSuperAdmin && (
            <button
              onClick={() => navigate('/company')}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow text-left group"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-purple-100 rounded-lg mb-4 group-hover:bg-purple-200 transition-colors">
                <Building2 className="w-6 h-6 text-purple-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900">View Entire Company Goals</h2>
              <p className="text-gray-500 mt-2">Access all employees' goals across the organization</p>
            </button>
          )}

          {isSuperAdmin && (
            <button
              onClick={() => navigate('/departmental')}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow text-left group"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-teal-100 rounded-lg mb-4 group-hover:bg-teal-200 transition-colors">
                <Briefcase className="w-6 h-6 text-teal-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900">Departmental Goals</h2>
              <p className="text-gray-500 mt-2">Manage and view goals by department</p>
            </button>
          )}

          {isDeveloper && (
            <button
              onClick={() => navigate('/developer')}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow text-left group"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-orange-100 rounded-lg mb-4 group-hover:bg-orange-200 transition-colors">
                <Code2 className="w-6 h-6 text-orange-600" />
              </div>
              <h2 className="text-xl font-semibold text-gray-900">Developer Tools</h2>
              <p className="text-gray-500 mt-2">Debug view with manager filters and system checks</p>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleSelection;
